/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionApplication } from './emrClusterDefinitionApplication';
import { EmrClusterDefinitionAutoTerminationPolicy } from './emrClusterDefinitionAutoTerminationPolicy';
import { EmrClusterDefinitionConfiguration } from './emrClusterDefinitionConfiguration';
import { EmrClusterDefinitionInstanceFleet } from './emrClusterDefinitionInstanceFleet';
import { EmrClusterDefinitionKerberosAttributes } from './emrClusterDefinitionKerberosAttributes';
import { HadoopJarStep } from './hadoopJarStep';
import { InstanceDefinitions } from './instanceDefinitions';
import { NodeTag } from './nodeTag';
import { Parameter } from './parameter';
import { ScriptDefinition } from './scriptDefinition';


export interface EmrClusterDefinition { 
    /**
     * The name of the Amazon EC2 key pair to set as the connection credential
     */
    sshKeyPairName?: string;
    /**
     * <p>A comma separated list of Amazon VPC subnets.</p>                   <ul>                   <li>When multiple subnets are specified, the subnet in the AZ with the best price will be used.</li>                   <li>When multiple subnets belong to the same AZ, the subnet with the largest amount of available IP's will be used.</li>                   </ul>                   <p>Cross-VPC access in PROD will only accept internal/emr subnets at this time.</p>                
     */
    subnetId?: string;
    /**
     * Amazon S3 bucket to receive log files
     */
    logBucket?: string;
    /**
     * Launch a cluster that continues running even after completing all its steps
     */
    keepAlive?: boolean;
    /**
     * Makes the instances in an existing cluster visible to all IAM users
     */
    visibleToAll?: boolean;
    /**
     * Launch the cluster with termination protection enabled
     */
    terminationProtection?: boolean;
    /**
     * Volume level encryption for the disks (using custom scripts). Encryption is not supported for AMI versions lower than                   3.1.0                
     */
    encryptionEnabled?: boolean;
    /**
     * The AWS account number, without dashes, to launch the Amazon EMR service in
     */
    accountId?: string;
    /**
     * Launches the Amazon EMR service with the specified IAM role
     */
    serviceIamRole?: string;
    /**
     * Launches the EC2 instances of a cluster with the specified IAM role
     */
    ec2NodeIamProfileName?: string;
    /**
     * Specify the version of the AMI to use
     */
    amiVersion?: string;
    /**
     * The release label. Available from 4.x
     */
    releaseLabel?: string;
    /**
     * Specify the version of Hadoop to install
     */
    hadoopVersion?: string;
    /**
     * The Hive version to load
     */
    hiveVersion?: string;
    /**
     * The Pig version to load
     */
    pigVersion?: string;
    installOozie?: boolean;
    /**
     * Bootstrapping scripts that are executed only on the Master node
     */
    customBootstrapActionMaster?: Array<ScriptDefinition>;
    /**
     * Bootstrapping scripts that are executed on all the nodes
     */
    customBootstrapActionAll?: Array<ScriptDefinition>;
    /**
     * Specifies additional information during cluster creation
     */
    additionalInfo?: string;
    instanceDefinitions?: InstanceDefinitions;
    /**
     * Specifies minimum number of available IPs required for the instance fleet
     */
    instanceFleetMinimumIpAvailableFilter?: number;
    /**
     * Describes the EC2 instances and instance configurations for clusters that use the instance fleet configuration. The instance                   fleet configuration is available only in Amazon EMR versions 4.8.0 and later, excluding 5.0.x versions                
     */
    instanceFleets?: Array<EmrClusterDefinitionInstanceFleet>;
    /**
     * Custom tags to be applied on the EC2 nodes
     */
    nodeTags?: Array<NodeTag>;
    /**
     * Installs third-party software on an Amazon EMR cluster
     */
    supportedProduct?: string;
    /**
     * List of applications
     */
    applications?: Array<EmrClusterDefinitionApplication>;
    /**
     * List of configurations
     */
    configurations?: Array<EmrClusterDefinitionConfiguration>;
    /**
     * Predefined bootstrap action to configure hadoop daemons
     */
    daemonConfigurations?: Array<Parameter>;
    /**
     * Predefined bootstrap action to specify hadoop configurations
     */
    hadoopConfigurations?: Array<string>;
    /**
     * Hadoop jar steps that are added, to be executed once the cluster is started
     */
    hadoopJarSteps?: Array<HadoopJarStep>;
    /**
     * List of additional master node security groups. The security group defined by the configuration value                   emr.herd.support.security.group will automatically be added whether this list is specified or not                
     */
    additionalMasterSecurityGroups?: Array<string>;
    /**
     * List of additional slave node security groups
     */
    additionalSlaveSecurityGroups?: Array<string>;
    /**
     * The name of a security configuration to apply to the cluster
     */
    securityConfiguration?: string;
    /**
     * The master security group to use instead of the account default value
     */
    masterSecurityGroup?: string;
    /**
     * The slave security group to use instead of the account default value
     */
    slaveSecurityGroup?: string;
    /**
     * The service access security group to use
     */
    serviceAccessSecurityGroup?: string;
    /**
     * Specifies the way that individual Amazon EC2 instances terminate when an automatic scale-in activity occurs or an instance                   group is resized. One of the following values: TERMINATE_AT_INSTANCE_HOUR or TERMINATE_AT_TASK_COMPLETION                
     */
    scaleDownBehavior?: string;
    kerberosAttributes?: EmrClusterDefinitionKerberosAttributes;
    /**
     * The step concurrency level of the cluster. Default is 1 which is non-concurrent. The maximum value is 256
     */
    stepConcurrencyLevel?: number;
    autoTerminationPolicy?: EmrClusterDefinitionAutoTerminationPolicy;
    /**
     * The size, in GiB, of the EBS root device volume of the Linux AMI that is used for each EC2 instance. This optional parameter                   can be a number from 10 (the default) up to 100 (GiB)                
     */
    ebsRootVolumeSize?: number;
}
